import type { Activity, UseGetActivityOptions } from "./activity.type";
import type { Int } from "@/types";

import { useGet } from "@/hooks/queries";

export const useGetActivity = (id?: Int, options?: UseGetActivityOptions) => {
  const { data, ...queryResult } = useGet<Activity>("activities", id, options);

  return {
    activity: data,
    ...queryResult,
  };
};
